import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import { GlobalState } from "./types";
import { Layers } from "@/models/map/layers";

const state: GlobalState = {
  isLoading: false,
  isLoggedIn: false,
  activeView: Layers.Customers
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
